/* global axios */

import ApiClient from './ApiClient';

/**
 * SuperTVGo: créditos dos painéis de revenda (IPTV/Atmos e UniTV Mensal/Anual).
 * `get` lê o último valor salvo; `atualizar` dispara a consulta em background.
 */
class SupertvgoSaldos extends ApiClient {
  constructor() {
    super('supertvgo_saldos', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  atualizar() {
    return axios.post(`${this.url}/atualizar`);
  }
}

export default new SupertvgoSaldos();
